import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'

const BugsnagWrapper = ({ children }: { children: React.ReactNode }) => {
  // Fly.io PR previews (NEXT_PUBLIC_PREVIEW_APP): no errors nor performance data sent to Bugsnag
  if (
    process.env.NEXT_PUBLIC_REACT_APP_ENVIRONMENT === 'development' ||
    process.env.NEXT_PUBLIC_PREVIEW_APP === 'true'
  ) {
    return <>{children}</>
  }

  Bugsnag.start({
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_ID!,
    appVersion: process.env.NEXT_PUBLIC_PACKAGE_VERSION,
    plugins: [new BugsnagPluginReact()],
    releaseStage: process.env.NEXT_PUBLIC_REACT_APP_ENVIRONMENT,
    onError: (event) => {
      event.setUser(sessionStorage.getItem('contactId') || undefined)
    },
    enabledReleaseStages: ['production', 'staging']
  })
  BugsnagPerformance.start({ apiKey: process.env.NEXT_PUBLIC_BUGSNAG_ID! })

  const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React)

  return <ErrorBoundary>{children}</ErrorBoundary>
}

export default BugsnagWrapper
